module.exports = __webpack_public_path__ + "media/images/search-9405cc4803831cfccd256949d3a0875b.png";